import AppDataService from "./AppDataService";

const COMMON_BASE = 'Forms'
const BULK_IMPORT_COMMON_BASE = 'BulkImportForm'

export default class FormsDataService {
    static async getFormsList() {
        return await AppDataService.get(`${COMMON_BASE}/GetForms`);
    }
    static async getFormFields(formId, formYear, formRecordId) {
        let urlParams = `formName=${formId}&year=${formYear}`;
        if(formRecordId){
            urlParams = `${urlParams}&formRecordId=${formRecordId}`
        }
        return await AppDataService.get(`${COMMON_BASE}/GetFormFields?${urlParams}`);
    }
    static async onDependentFieldChangeGetValues(onDependentFieldChangeData) {
        return await AppDataService.post(`${COMMON_BASE}/CalculateInferredValues`, onDependentFieldChangeData);
    }
    static async getFormData(formId, formYear, formRecordId = 0) {
        return await AppDataService.get(`${COMMON_BASE}/GetFormData?formId=${formId}&year=${formYear}&formRecordId=${formRecordId}`);
    }
    static async saveForm(formId, formData) {
        return await AppDataService.post(`${COMMON_BASE}/Save`, formData);
    }

    static async getCascadeForms() {
        return await AppDataService.get(`${COMMON_BASE}/GetCascadeForms`);
    }

    static async getCascadeTaxYears(formId) {
        return await AppDataService.get(`${COMMON_BASE}/GetCascadeTaxYear?formId=${formId}`);
    }

    static async getCascadePayers(formId) {
        return await AppDataService.get(`${COMMON_BASE}/GetCascadePayers?formId=${formId}`);
    }

    static async checkUseSavedOrStartNewImport(formId, year) {
        return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/CheckForSavedData?formName=${formId}&year=${year}`);
    }
    
    static async continueWithSavedData(formId, year) {
        return await AppDataService.put(`${BULK_IMPORT_COMMON_BASE}/SetContinueWithSaved?formName=${formId}&year=${year}`);
    }
    static async uploadFile(formId, data, year) {
        return await AppDataService.post(`${BULK_IMPORT_COMMON_BASE}/UploadFile?formName=${formId}&year=${year}`, data);
    }

    static async submitFileOrPastedData(formId, data, year) {
        return await AppDataService.put(`${BULK_IMPORT_COMMON_BASE}/SubmitFileOrData?formName=${formId}&year=${year}`, data);
    }

    static async getFieldsForMatching(formId, year) {
        return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/MatchFields?formName=${formId}&year=${year}`);
    }

    static async submitMatchedFields(formId, data, year, quarter) {
        let quarterParam = "";
        if(quarter){
            quarterParam = `&quarter=${quarter}`
        }
        return await AppDataService.post(`${BULK_IMPORT_COMMON_BASE}/PushFileData?formName=${formId}&year=${year}${quarterParam}`, data)
    }

    static async downloadBatchImportTemplate(formId, year, fileType, quarter) {
        let quarterParam = "";
        if(quarter){
            quarterParam = `&quarter=${quarter}`
        }
        return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/BulkImportDownloadSample?formId=${formId}&taxyear=${year}&fileType=${fileType}${quarterParam}`);
    }
    
    static async getFormGridRecordsList(formId, requestBody, year) {
        return await AppDataService.post(`${BULK_IMPORT_COMMON_BASE}/GetFormGridDetailRecords?formName=${formId}&year=${year}`, requestBody)
    }
    
    static async getFormGridFieldsData(formId, year) {
        return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/GetGridPageFormData?formName=${formId}&year=${year}`);
    }
    
    static async setSelectedPayerList(formId, payerList, year) {
        return await AppDataService.post(`${BULK_IMPORT_COMMON_BASE}/SetSelectedPayerList?formName=${formId}&year=${year}`, payerList)
    }

    static async downloadExcelReport(formId, reportType, year) {
        if(reportType === "RECORDS_REPORT"){
            return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/ExportToExcel?formName=${formId}&year=${year}`);    
        }else if(reportType === "ERROR_REPORT"){
            return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/GetErrorSheet?formName=${formId}&year=${year}`);    
        }else{
            return false;
        }
    }

    static async checkStateFilingApplicable(formId) {
        return await AppDataService.get(`${COMMON_BASE}/CheckStateFilingForm?formId=${formId}`);
    }

    static async checkPayerValid(formId, payerIds, year) {
        return await AppDataService.post(`${BULK_IMPORT_COMMON_BASE}/CheckPayerValid?formName=${formId}&year=${year}`, payerIds);
    }
    
    static async updateSingleBox(formId, data, year) {
        return await AppDataService.put(`${BULK_IMPORT_COMMON_BASE}/UpdateBoxValue?formName=${formId}&year=${year}`, data);
    }
    
    static async deleteSingleRecord(formId, data, year) {
        return await AppDataService.delete(`${BULK_IMPORT_COMMON_BASE}/DeleteFormRecord?formName=${formId}&year=${year}`, data)
    }

    static async updateTinNotProvided(formId, year) {
        return await AppDataService.put(`${BULK_IMPORT_COMMON_BASE}/UpdateTINNotProvided?formName=${formId}&year=${year}`)
    }

    static async applyBoxToSelectedRecords(formId, requestBody, year) {
        return await AppDataService.post(`${BULK_IMPORT_COMMON_BASE}/ApplyBoxNoToSelected?formName=${formId}&year=${year}`, requestBody);
    }

    static async bulkImportSubmit(formId, requestBody, year) {
        return await AppDataService.post(`${BULK_IMPORT_COMMON_BASE}/BulkImportSubmit?formName=${formId}&year=${year}`, requestBody);
    }

    static async getFormDetails(formName, formRecordId) {
        return await AppDataService.get(`${COMMON_BASE}/GetForm?formName=${formName}&formRecordId=${formRecordId}`);
    }
    
    static async getRecipientDataForEdit(formId, recipientName, year, mappingId) {
        return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/GetEditRecipient?PayeeName=${recipientName}&formName=${formId}&year=${year}&mappingId=${mappingId}`);
    }
    
    static async submitEditedPayer(formId, payerData, year, mappingId) {
        return await AppDataService.put(`${BULK_IMPORT_COMMON_BASE}/EditPayer?formName=${formId}&year=${year}&mappingId=${mappingId}`, payerData);
    }
    
    static async submitEditedRecipient(formId, recipientData, year, mappingId) {
        return await AppDataService.put(`${BULK_IMPORT_COMMON_BASE}/EditRecipient?formName=${formId}&year=${year}&mappingId=${mappingId}`, recipientData);
    }

    static async getFormFromRecordId(formId, recordId,page) {
        return await AppDataService.get(`${COMMON_BASE}/GetForm?formName=${formId}&formRecordId=${recordId}&page=${page}`);
    }
    
    static async getFormSetting(formId, year) {
        return await AppDataService.get(`${BULK_IMPORT_COMMON_BASE}/GetFormSetting?formName=${formId}&year=${year}`);
    }

    static async GetGuidedFormList() {
        return await AppDataService.get(`${COMMON_BASE}/GetGuidedFormList`);
    }

    static async getStatePayrollFromRecordId(formId, recordId,page) {
        return await AppDataService.get(`${COMMON_BASE}/GetStatePayrollForm?formName=${formId}&formRecordId=${recordId}&page=${page}`);
    }

    static async statePayrollSaveForm(formId, formData) {
        return await AppDataService.post(`${COMMON_BASE}/PayrollSave`, formData);
    }
}